import { homeV2Data, HomeV2DataType } from "@/shared/data/home.v2.data";
import { getCDNURL } from "@/shared/utils/commons";

const seoDataUs = {
  title: "Graphy - Build & Sell Courses, Memberships, Digital Products and More",
  description:
    "Trusted by 200000+ creators & businesses to build, sell and scale courses, memberships, digital products and more. Start for free.",
  canonicalPath: "",
  countryCode: "US",
};

// Root for all US-differential home-page assets on the CDN. The S3 mirror
// preserves the on-disk "Home Page US Images" folder name, so US overrides
// only need to be listed for the handful of files that actually differ
// from India — everything else continues to resolve via homeV2Data.
const US_HOME_IMAGES = `${getCDNURL()}graphy-web/V4/images/Home Page/Home Page US Images`;

export const homeV2DataUs: HomeV2DataType = {
  ...homeV2Data,
  seoData: seoDataUs,
  hero: {
    ...homeV2Data.hero,
    titleMuted: "Turn Your Knowledge Into",
    titleBright: "Your First Online Income with AI",
    description:
      "Create your first course, coaching program, or digital product — without a team, tech skills, or months of setup. Graphy guides you step by step, so you can launch confidently.",
    stats: [
      { value: "200,000+", label: "Creators Worldwide" },
      { value: "$1.5 Billion+", label: "Creator Revenue" },
      { value: "4.8/5", label: "Rating" },
      { value: "150+", label: "Countries Served" },
    ],
    creatorAvatars: [
      {
        src: `${US_HOME_IMAGES}/hero section images/Creator 02.png`,
        alt: "Devon Michael Sangiovanni",
        name: "Devon Michael Sangiovanni",
        role: "Educator",
      },
      {
        src: `${US_HOME_IMAGES}/hero section images/Creator 03.png`,
        alt: "John Evans",
        name: "John Evans",
        role: "Golf Coach",
      },
      {
        src: `${US_HOME_IMAGES}/hero section images/Creator 04.png`,
        alt: "Kara Smith",
        name: "Kara Smith",
        role: "Leadership Trainer",
      },
      {
        src: `${US_HOME_IMAGES}/hero section images/Creator 05.png`,
        alt: "Kimberly Clark",
        name: "Kimberly Clark",
        role: "Digital Entrepreneur",
      },
      {
        src: `${US_HOME_IMAGES}/hero section images/Creator 01.png`,
        alt: "Bradley Thomson",
        name: "Bradley Thomson",
        role: "Sales Coach",
      },
      {
        src: `${US_HOME_IMAGES}/hero section images/Creator 07.png`,
        alt: "Suzanne Andora Barron",
        name: "Suzanne Andora Barron",
        role: "Wellness Coach",
      },
      {
        src: `${US_HOME_IMAGES}/hero section images/Creator 08.png`,
        alt: "Ahmy Brock",
        name: "Ahmy Brock",
        role: "Life Guide",
      },
    ],
  },
  platformTabs: {
    ...homeV2Data.platformTabs,
    tabs: homeV2Data.platformTabs.tabs.map((tab) => {
      if (tab.id === "coaching") {
        return {
          ...tab,
          image: `${US_HOME_IMAGES}/Feature Section/Coaching.png`,
        };
      }
      if (tab.id === "webinars") {
        return {
          ...tab,
          image: `${US_HOME_IMAGES}/Feature Section/Webinar.png`,
        };
      }
      return tab;
    }),
  },
  automations: {
    ...homeV2Data.automations,
    features: homeV2Data.automations.features.map((feature) => {
      if (feature.id === "analytics") {
        return {
          ...feature,
          image: `${US_HOME_IMAGES}/Sell Section/Analytics That Tell You What Works.png`,
        };
      }
      if (feature.id === "support-that-scales") {
        // US uses the `_us` suffix variant of the same illustration rather
        // than a fully separate folder, since only the rendered text inside
        // the image differs from the India version.
        return {
          ...feature,
          image: `${getCDNURL()}graphy-web/V4/images/Home Page/Sell Section/Support That Scales Infinitely_us.png`,
        };
      }
      if (feature.id === "grow-your-audience") {
        return {
          ...feature,
          bullets: feature.bullets?.map((b) =>
            b.text === "Email and WhatsApp campaign setup"
              ? { ...b, text: "Email campaign setup" }
              : b
          ),
        };
      }
      return feature;
    }),
  },
  creatorsGrid: {
    ...homeV2Data.creatorsGrid,
    image: `${US_HOME_IMAGES}/Stories Section image/stories creator images.png`,
  },
  footer: {
    ...homeV2Data.footer,
    socialLinks: homeV2Data.footer.socialLinks.map((link) =>
      link.kind === "mail"
        ? { ...link, href: "mailto:team@graphy.com" }
        : link
    ),
  },
};
